import { getCurrentLocale } from '@/utils/utils';
import { request } from 'umi';

export async function createQuote({
  answers,
  client,
  quoteCode,
  isDraft,
  answersKey,
  askCallName,
  askCallPhone,
  askCallContactTime,
  isDemo,
  isRenew,
  sendMail,
  isSendContactMail,
  saveDraftInfo,
  isHiddenPrice,
}: {
  answers: any;
  client: string;
  quoteCode: string;
  isDraft?: number;
  answersKey: any;
  askCallName?: string;
  askCallPhone?: string;
  askCallContactTime?: string;
  isDemo?: number;
  isRenew?: boolean;
  sendMail: boolean;
  isSendContactMail: boolean;
  saveDraftInfo?: any;
  isHiddenPrice: boolean;
}) {
    const data: any = {
    answers: JSON.stringify(answers),
    client,
    locale: getCurrentLocale(),
    quoteCode,
    answersKey: JSON.stringify(answersKey),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  if (isDraft) data.isDraft = isDraft;
  if (askCallName) data.askCallName = askCallName;
  if (askCallPhone) data.askCallPhone = askCallPhone;
  if (askCallContactTime) data.askCallContactTime = askCallContactTime;
  if (isDemo) data.isDemo = isDemo;
  if (isRenew) data.isRenew = 1;
  if (sendMail) data.sendMail = 1;
  if (isSendContactMail) data.isSendContactMail = 1;
  if (saveDraftInfo) data.saveDraftInfo = JSON.stringify(saveDraftInfo);
  if (isHiddenPrice) data.isHiddenPrice = 1;
  return request<API.Quote>('/api/quotes', {
    method: 'POST',
    data,
  });
}

export function generatePDF(quoteCode: string) {
  return request<API.File>(`/api/quotes/${quoteCode}/generatePdf`, {
    method: 'GET',
    params: {
      locale: getCurrentLocale(),
    },
  });
}

export function generateQuoteCode(appType?: string) {
  return request<{ quoteCode: string }>(`/api/quotes/generate/code`, {
    method: 'GET',
    params: {
      appType
    },
  });
}

export function getQuoteHistory({ quoteCode, client, token }: { quoteCode: string; client: string, token?: string }) {
  const params: any = { client };
 
    const staffSessionStr = window.sessionStorage.getItem('staffSession');
  if(staffSessionStr){
    let token = undefined;
    if (staffSessionStr) {
      const staffSessionObj = JSON.parse(staffSessionStr);
      token = staffSessionObj.token;
    }
    const headers: any = {};
    if (token) {
      headers['x-staff-token'] = `Bearer ${token}`;
    }
    return request<API.Quote>(`/api/quotes/${quoteCode}/getHistoryQuote`, {
      method: 'GET',
      params,
      headers,
    });
  }

   if (token) {
    params.token = token;
  }
   return request<API.Quote>(`/api/quotes/${quoteCode}`, {
    method: 'GET',
    params,
  });
}

export function getListOldQuotes({ quoteCode, client }: { quoteCode: string; client: string }) {
 

  const staffSessionStr = window.sessionStorage.getItem('staffSession');
  let token = undefined;
  if (staffSessionStr) {
    const staffSessionObj = JSON.parse(staffSessionStr);
    token = staffSessionObj.token; 
  }
  const headers: any = {};
   if (token) {
    headers['x-staff-token'] = `Bearer ${token}`;
   }

  return request<API.Quote>(`/api/quotes/${quoteCode}/related_list`, {
    method: 'GET',
    headers,
    params: {
      client,
      locale: getCurrentLocale(),
    
    },
  });
}
